'use client';

import { c as _c } from "react/compiler-runtime";
import { useSuspenseQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import { resolveLottoPotGauge } from '../_utils/resolveLottoPotGauge';

//* 적립금 풀은 서비스 공동 값(인증 불요) — 비회원·회원이 동일 게이지를 본다.
export const useLottoPool = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/benefit-lottery/pool"](),
      select: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useSuspenseQuery(t0);
};
function _temp(data) {
  const accumulatedAmount = data?.context?.currentAmount ?? 0;
  const targetAmount = data?.context?.goalAmount ?? 0;
  return {
    accumulatedAmount,
    targetAmount,
    potGauge: resolveLottoPotGauge({
      accumulatedAmount,
      targetAmount
    })
  };
}